import(/* webpackMode: "eager" */ "/build/apps/web/src/app/global-error.tsx");
